import React, { useEffect } from 'react';
import ReactDom from 'react-dom';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { useNotificationsUIContext } from 'common/Popup/NotificationsUIContext';
import PopupBackdrop from 'common/Popup/PopupBackdrop';

import { useLocalBetslip } from './LocalBetslipContext';

const BetslipPopupWrapper = ({ children, className, onClose }) => {
  const { isOpenPopup } = useLocalBetslip();
  const { emitBetslipToggle } = useNotificationsUIContext();

  useEffect(() => {
    emitBetslipToggle(isOpenPopup);
  }, [isOpenPopup]);

  const wrapperClassName = cx('betslip-popup', { hidden: !isOpenPopup });

  const backdropClassName = cx({ 'popup-backdrop-hidden': !isOpenPopup });
  const contentClassName = cx(className, { hidden: !isOpenPopup });

  return ReactDom.createPortal(
    <div className={wrapperClassName}>
      <PopupBackdrop className={backdropClassName} onClick={onClose} />

      <div className={contentClassName} data-testid="betslip">
        {children}
      </div>
    </div>,
    document.body,
  );
};

BetslipPopupWrapper.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default BetslipPopupWrapper;
